<template>
  <div
    class="h-full"
    v-loading="tableLoading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <categoryTitle class="mt-10px mb-10px" title="目录关联设备列表" />
    <div class="flex mb-5px">
      <el-select
        v-model="nodeForm.fatherNode"
        size="medium"
        placeholder="请选择目录"
        clearable
        ref="fatherNode"
        @clear="handleClear"
      >
        <el-input
          placeholder="此处输入关键词搜索查询"
          prefix-icon="el-icon-search"
          v-model="smallTreeFilter"
          size="mini"
          clearable
        ></el-input>
        <el-option hidden key="id" :label="selectName" :value="selectName"></el-option>
        <el-tree
          v-loading="deviceTreeLoading"
          ref="smallTreeDom"
          :data="treeData"
          empty-text="暂无数据"
          highlight-current
          :props="defaultTreeProps"
          :expand-on-click-node="false"
          :default-expand-all="false"
          :filter-node-method="filterTreeNode"
          @node-click="selectHandler"
          class="text-14px mt-10px"
        >
        </el-tree>
      </el-select>
      <div class="icon-search__input ml-2px">
        <el-input
          placeholder="设备名称或编码"
          v-model="keyword"
          size="small"
          clearable
          @keypress.enter.native="currentChange(1)"
        >
          <i slot="append" class="el-icon-search cursor-pointer" @click="currentChange(1)"></i>
        </el-input>
      </div>
    </div>
    <el-table
      :data="tableData"
      :height="`calc(100% - 156px)`"
      highlight-current-row
      @row-click="rowClick"
    >
      <el-table-column label="" width="20">
        <template slot-scope="scope">
          <i class="el-icon-check text-[#67C23A] font-bold" v-show="scope.row.moduleStatus"></i>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="设备名称"></el-table-column>
      <el-table-column prop="code" label="设备编码"></el-table-column>
    </el-table>
    <el-pagination
      class="mt-10px flex justify-center"
      background
      @current-change="currentChange"
      @size-change="sizeChange"
      :current-page="initPagination.pageNum"
      :page-size="initPagination.pageSize"
      layout="total, prev, pager, next"
      :total="initPagination.total"
      :pager-count="5"
    >
    </el-pagination>
  </div>
</template>

<script>
import _ from 'lodash'
import categoryTitle from '@/components/cockpit/CategoryTitle'

const baseUrl = Wiz.GetModuleServer()

export default {
  name: 'deviceList',
  components: {
    categoryTitle,
  },
  props: {
    player: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      keyword: '',
      level: ['A', 'B'], // 业务需求，默认查询A、B等级的设备
      nodeForm: {
        id: '',
        fatherId: '',
        fatherNode: '',
        nodeName: '',
        seqNo: 1,
      },
      smallTreeFilter: '',
      selectName: '',
      deviceTreeLoading: false,
      treeData: [],
      defaultTreeProps: {
        children: 'children',
        label: 'name',
      },
      tableData: [],
      tableLoading: false,
      initPagination: {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      },
      selectItem: null,
    }
  },
  watch: {
    smallTreeFilter(val) {
      this.$refs.smallTreeDom.filter(val)
    },
  },
  methods: {
    async rowClick(row) {
      this.$emit('row-click', row)
    },
    /**
     * @description: 搜索区域树
     * @param {*} value
     * @param {*} data
     * @return {*}
     */
    filterTreeNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    async selectHandler(data) {
      this.nodeForm.id = data.code
      this.nodeForm.fatherNode = data.name
      this.nodeForm.fatherId = data.code
      this.selectName = data.name
      this.smallTreeFilter = ''
      this.$refs.fatherNode.blur()
      await this.getList()
    },
    handleClear() {
      this.nodeForm.id = null
    },
    currentChange(val) {
      this.initPagination.pageNum = val
      this.getList()
    },
    sizeChange(val) {
      this.initPagination.pageSize = val
      this.initPagination.pageNum = 1
      this.getList()
    },
    async getList() {
      this.tableLoading = true
      const res = await axios({
        method: 'GET',
        url: `${baseUrl}/openapi/devices/paged-list/position/V1.0?token=portal_js`,
        params: {
          pageNo: this.initPagination.pageNum,
          pageSize: this.initPagination.pageSize,
          treeCode: this.nodeForm.id ? this.nodeForm.id : '',
          keyword: this.keyword ? `${this.keyword}` : '',
          level: this.level.join(','),
          isPosition: 0
        },
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
      })

      if (res.data.code === 200) {
        this.tableData = res.data.data.items
        this.initPagination.total = res.data.data.totalCount
      }
      this.tableLoading = false
    },
    // 转换成树形结构
    transformData(data) {
      if (!Array.isArray(data)) {
        return []
      }
      const map = {}
      const tree = []
      data.forEach((item) => {
        if (item.code) {
          map[item.code] = { code: item.code, name: item.name, children: [] }
        }
      })
      // 构建树形结构
      data.forEach((item) => {
        if (!item.parentCode) {
          // 如果没有父节点，则为根节点
          if (map[item.code]) {
            tree.push(map[item.code])
          }
        } else if (map[item.parentCode]) {
          // 将当前节点加入到父节点的 children 中
          map[item.parentCode].children.push(map[item.code])
        }
      })
      return tree
    },
    /**
     * @description: 获取树数据
     * @return {*}
     */
    async getTreeData() {
      const res = await axios({
        method: 'GET',
        url: `${baseUrl}/openapi/devices/get-tree/V1.0?token=portal_js`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
      })
      if (res && !_.isNil(res.data?.data)) {
        this.treeData = this.transformData(res.data.data)
        await this.selectHandler(this.treeData[0])
      }
    },
  },
  computed: {
    getKksCode() {
      return (kksCode) => {
        const prefix = kksCode.slice(0, 4)
        if (prefix === '6760') {
          return kksCode.slice(4, kksCode.length)
        }
        return kksCode
      }
    },
  },
  async created() {
    this.getTreeData()
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-table {
    font-size: 13px;
    .cell {
      line-height: 14px;
    }
  }
  .el-pagination {
    padding: 2px 0;
    .el-pagination__total {
      font-size: 12px;
      margin-right: 5px;
    }
    .el-pager {
      li {
        margin: 0 1px;
        font-size: 12px;
        min-width: 25px;
      }
    }
    .btn-prev,
    .btn-next {
      margin: 0 1px;
      min-width: 25px;
    }
  }
}
</style>
